import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './restore_site.component.html'
})
export class RestoreSiteModalComponent extends BaseSupportModalComponent {
	siteId: string;

	async ok() {
		if(confirm(`Вы уверены, что хотите восстановить сайт ${this.title}?`)) {
			await this.supportService.restoreSite(this.siteId, this.comment).toPromise();

			this.execute();			
		}
	}
}
